import { useCallback } from "react";
import URI from "urijs";
import useHistory from "routing/useHistory";
import useInvestigationPanel from "security-app/components/Investigations/hooks/useInvestigationPanel";
const toFilterQuery = (filters) => (filters == null ? void 0 : filters.isEmpty()) === false ? {
  filters: filters.entrySeq().toArray().flatMap(([attributeId, values]) => values.map((value) => `${attributeId}=${value}`))
} : "";
const useGoToEvidencePage = (investigationId, destination, filters) => {
  const history = useHistory();
  const { openInvestigation, setSelectedInvestigationId } = useInvestigationPanel();
  return useCallback(() => {
    setSelectedInvestigationId(investigationId);
    openInvestigation(investigationId);
    const url = new URI(destination);
    url.setQuery(toFilterQuery(filters));
    history.push(url.toString());
  }, [destination, filters, history, investigationId, openInvestigation, setSelectedInvestigationId]);
};
export default useGoToEvidencePage;
